import { createContext, useContext, useState, useMemo } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getBlogs, deleteBlog, getBlogsPage, addBlogsPage, updateBlogsPage } from "../../api/blogs";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();


export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [term, setTerm] = useState("");


  const getBlogsQuery = useQuery({
    queryKey: ["blogs", term],
    queryFn: () => getBlogs(term),
  });

  const getBlogsPageQuery = useQuery({
    queryKey: ["blogs-page"],
    queryFn: () => getBlogsPage(),
  });

  const blogsPageData = getBlogsPageQuery.data?.data?.[0] || {};

  const initialValues = useMemo(() => {
    return {
      meta: blogsPageData.meta || { meta_title: "", keywords: "", meta_description: "" },
    };
  }, [getBlogsPageQuery.data]);

  const addBlogsPageMutation = useMutation({ mutationFn: addBlogsPage });
  const updateBlogsPageMutation = useMutation({ mutationFn: updateBlogsPage });

  const handleSubmit = (values) => {
    if (blogsPageData._id) {
      updateBlogsPageMutation.mutate({ id: blogsPageData._id, ...values }, {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, "Blogs page SEO updated successfully.");
          queryClient.invalidateQueries(["blogs-page"]);
        },
        onError: (err) => {
          console.error(err);
          toaster.error("Error", "Failed to update SEO.");
        }
      });
    } else {
      addBlogsPageMutation.mutate(values, {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, "Blogs page SEO added successfully.");
          queryClient.invalidateQueries(["blogs-page"]);
        },
        onError: (err) => {
          toaster.error("Error", "Failed to add SEO.");
        }
      });
    }
  };

  const deleteBlogQuery = useMutation({ mutationFn: deleteBlog });

  const handleWorkDelete = (item) => {
    deleteBlogQuery.mutate(item._id, {
      onSuccess: () => {
        queryClient.invalidateQueries(["blogs"]);
        toaster.success(Const.MESSAGES.SUCCESS, "Blog is deleted successfully.");
      },
    });
  };

  const handleAddBlogClick = () => {
    navigate("/add-blog");
  };

  const handleEditClick = (item) => {
    navigate(`/add-blog?id=${item.slug_url}`);
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    setTerm(value);
  };


  return (
    <PageContext.Provider value={{ initialValues, handleSubmit, getBlogsQuery, handleWorkDelete, handleAddBlogClick, handleEditClick, handleOnChange }}>
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};
